export default "__VITE_ASSET__BS$PfaQs__"